module.exports = __webpack_public_path__ + "img/平顶山市.902d66a5.png";